import Head from 'next/head';
import { Component, Fragment, useEffect, useState } from 'react';
import styles from './event-layout.module.css';
import { setBodyClass } from "@/lib/site";
import { getContrast, getSessionCookie, getVisitorCookie } from "@/lib/site";

export default function Layout({ children, title = 'Make ticketing the least of your worries', logo = '', theme = 'rgb(73,73,73)', org_url_string = '', org_title = '', event_image = '', meta_description = '', page_url = '', event_id = '0', robots_meta="index,follow", org_id = '0', favicon = '' }) {
	const headerFontColor = getContrast(theme);
	const [pathname, setPathname] = useState('');

	useEffect(() => { setBodyClass('event-layout'); setPathname( window.location.pathname ); getSessionCookie(); getVisitorCookie(); }, []);

	return ( 
		<Fragment>
			<Head>
				<title>{title + " | INTIX"}</title>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
				<meta name="description" content={meta_description} />
				<meta name="theme-color" content={theme} />
			
				{ favicon != null && favicon.length > 0 ? ( <link rel="shortcut icon" href={"https://d2jun3ty2bmcrf.cloudfront.net/org/" + org_url_string + "/" + favicon} /> ) : logo != null && logo.length > 0 ? ( <link rel="shortcut icon" href={"https://d2jun3ty2bmcrf.cloudfront.net/org/" + org_url_string + "/" + logo} /> ) : ( <link rel="shortcut icon" href="https://d2jun3ty2bmcrf.cloudfront.net/website/img/favicon.png" /> )}
				
				<link rel="apple-touch-icon" href="https://d2jun3ty2bmcrf.cloudfront.net/website/img/favicon.png" />
				<link rel="apple-touch-icon" href="https://d2jun3ty2bmcrf.cloudfront.net/website/img/favicon.png" sizes="72x72" />
				<link rel="apple-touch-icon" href="https://d2jun3ty2bmcrf.cloudfront.net/website/img/favicon.png" sizes="114x114" />
				<link rel="apple-touch-icon" href="https://d2jun3ty2bmcrf.cloudfront.net/website/img/favicon.png" sizes="144x144" />

				<meta name="google-site-verification" content="7Y-IeU_nakeX7HweSzU-nUYGL2uAIlDaol8Mxen34d0" />
				<meta name="robots" content={robots_meta} />

				<meta name="apple-mobile-web-app-title" content="INTIX" />
				<meta name="application-name" content="INTIX" />
				<meta property="fb:app_id" content="444123852284030" />
				<meta property="og:url" content={page_url} />
				<meta property="og:title" content={title} />
				<meta property="og:type" content="website" />
				<meta property="og:image" content={"https://d2jun3ty2bmcrf.cloudfront.net/event/" + event_id + "/" + event_image} />
				<meta property="og:description" content={meta_description} />
				<meta property="og:site_name" content="INTIX" />
				<meta property="intix:event_id" content={event_id} />
				<meta property="intix:org_id" content={org_id} />
			</Head>
			{children}
		</Fragment>
	)
}